import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const menuItems = [
  { id: "home", label: "Home" },
  { id: "pool", label: "수영장" },
  { id: "filter", label: "여과기" },
  { id: "cases", label: "시공사례" },
  { id: "gallery", label: "갤러리" },
];

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Background change logic
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Active section logic
      const sections = menuItems.map((item) => document.getElementById(item.id));
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      sections.forEach((section) => {
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.clientHeight;
          if (scrollPosition >= sectionTop && scrollPosition < scrollPosition + sectionHeight) {
            if (window.scrollY + (window.innerHeight / 3) >= sectionTop && window.scrollY + (window.innerHeight / 3) < sectionTop + sectionHeight) {
              setActiveSection(section.id);
            }
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  const MobileMenu = () => {
    if (!isMobileMenuOpen) return null;

    return createPortal(
      <div className="fixed inset-0 z-[9999] overflow-hidden">
        <div
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
          onClick={() => setIsMobileMenuOpen(false)}
        />
        <div
          className="fixed inset-y-0 right-0 w-full max-w-sm bg-white shadow-2xl overflow-y-auto transition duration-300 ease-in-out transform translate-x-0"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-8">
            <div className="flex justify-between items-center mb-12">
              <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-400">
                워터피아
              </span>
              <button
                className="p-2 text-slate-500 hover:text-blue-600 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <ul className="space-y-6">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className={`block w-full text-left text-2xl font-medium transition-all ${activeSection === item.id
                      ? "text-blue-600 tracking-wide"
                      : "text-slate-600 hover:text-blue-500"
                      }`}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
            <div className="mt-20 pt-8 border-t border-slate-100">
              <p className="text-sm text-slate-400 mb-2 font-medium uppercase tracking-widest">Contact</p>
              <a href="tel:010-5113-4637" className="text-xl font-bold text-slate-800 hover:text-blue-600 transition-colors">
                010-5113-4637
              </a>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[60] transition-all duration-500 ${isScrolled
        ? "py-3 bg-white/80 backdrop-blur-lg shadow-sm border-b border-white/20"
        : "py-6 bg-transparent"
        }`}
    >
      <nav className="container mx-auto px-6">
        <div className="flex justify-between items-center">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-2xl font-extrabold tracking-tight transition-colors duration-300 ${isScrolled ? "text-blue-600" : "text-white"
              }`}
          >
            워터피아
          </button>
          <button
            className={`md:hidden p-2 transition-colors duration-300 ${isScrolled ? "text-slate-600" : "text-white"
              }`}
            onClick={() => setIsMobileMenuOpen(true)}
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
          <ul className="hidden md:flex items-center space-x-10">
            {menuItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className={`relative text-sm font-semibold uppercase tracking-widest transition-all duration-300 hover:text-blue-500 group ${isScrolled ? "text-slate-600" : "text-white/90"
                    } ${activeSection === item.id ? (isScrolled ? "text-blue-600" : "text-white") : ""}`}
                >
                  {item.label}
                  <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-500 transition-all duration-300 ${activeSection === item.id ? "w-full" : "w-0 group-hover:w-full"
                    }`} />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      <MobileMenu />
    </header>
  );
}

export default Header;
